const _ = require('lodash');
const Blockly = require('blockly');

module.exports = {
    gatherAllListsIntoChildren,
    appendStatements,
    blockName,
    addSecurityModifiersToCode,
    addSecurityModifiersToBlock,
    prettyName
};

function gatherAllListsIntoChildren(code, block) {
    const children = [];
    block.inputList.forEach(input => {
        if (input.type === Blockly.NEXT_STATEMENT) {
            let listStatements = Blockly.JavaScript.statementToCode(block, input.name);
            if (listStatements) {
                const listBlocks = JSON.parse(`[${listStatements}]`);
                // Mark blocks that are grouped together in the blockly UI (e.g. children, filters, formButtons, columns)
                listBlocks.forEach(block => {
                    block.hNodeBlockGroup = input.name;
                    children.push(block);
                });
            }
        }
    });
    if (children.length > 0) {
        code.children = children;
    }
}

function appendStatements(currentStatements, newStatements) {
    if (currentStatements && currentStatements.length > 0) {
        if (newStatements.length > 0) {
            return currentStatements + ',' + newStatements;
        } else {
            return currentStatements;
        }
    } else {
        return newStatements;
    }
}

function blockName(hNodeType, hNodeTypeGroup) {
    return hNodeTypeGroup + '_' + hNodeType;
}

function addSecurityModifiersToCode(code, block) {
    const childrenSecurityModifiers = Blockly.JavaScript.valueToCode(
        block,
        'securityModifier',
        Blockly.JavaScript.ORDER_NONE
    );
    if (childrenSecurityModifiers) {
        // Copy security modifiers over to the code object.
        Object.assign(code, JSON.parse(childrenSecurityModifiers));
    }
}

 
function addSecurityModifiersToBlock(block) {
    block
        .appendValueInput('securityModifier')
        .setCheck('securityModifier')
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(new Blockly.FieldImage(whiteLockUrl, 25, 25, '*'));

    // find first statement input
    let firstStatementInput = block.inputList.find(input => input.type === Blockly.NEXT_STATEMENT);
    if (firstStatementInput) {
        block.moveInputBefore('securityModifier', firstStatementInput.name);
    }
}

function prettyName(hNodeTypeTitle) {
    return _.startCase(hNodeTypeTitle) + '  |';
}

const whiteLockUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAB6ElEQVRIS2MYBUMecAOxMBBzgHnUBLpyckrLJ0yadP3k6cuPTp56fP3U6TNLe/qrZfj4hKBKKAOhbm7G9y5dvvcfCP78/PX/07Pn///9/vP//79//6/u2XvESVFRHKqUbMB3YffekyALnh49/nhHYnLivuRk6wPFZXkvL1z8ABK/tG37LKA6ZohyMkCBq6vbry9f/r+9dfvvgexsXagwGBwoKQn89vb9/w+PHn+fnZxMfrCtbWgqB7n27tZtl6FCcOBibMz/aN/B76Bg21dSaQ0VJh2sr6xuAVlyZeOmE0AuGxAzIWGxG5s2vwfJ74qL8wPyGYGYNNCfk593bdfuGyBDnl+4+PbY/AU7dq1as3/n2vUHQHj34sUH3t65+wskf3PjpqMb2ruyoVqJB/tXrFoAMoBY8OjK1YVQrcSDQ5u3zIbqh4P3d++9u79tx4R3t+88gwrBweOr1xdAtRIPDm/ZNguqHw6uzVvQApLbVtdQDRWCA6pZ8mDf/pvc3NxiF1evuQoVggOqWfLizNnnQCnhO/sPPIQKwQFZlhzdtmMGVD8c3Nm+41q2iUnE2WXLL0OF4IAsSy7t2Vf/9unTH8j49YOHP55fu/nj9f2HKOIgfP/UmUlQraQBoAOZSMCkZ8ZRMJwBAwMAZZULtC2ccEQAAAAASUVORK5CYII=';
